<template>
  <div class="main-container">
    <el-row>
      <el-col>
        <el-card>
          <h3 style="text-align: center; letter-spacing: 5px;">🎈欢迎来到风铃笔记🎈</h3>
          <p>🌈这里是「风铃笔记」，一个专注于记录与分享学习点滴的小角落。我会在这里分享自己的学习笔记、遇到的问题以及解决方法💡，偶尔也会更新一些新学到的小知识。📚</p>
          <p>🍻如果你也喜欢记录、分享学习过程，也欢迎你加入风铃笔记，发布自己的学习心得，分享宝贵经验，一起记录成长的足迹，在交流中共学共进。🍦</p>
          <p>💪搭建风铃笔记本身也是一个不断学习的过程。虽然现在它看起来有点简单，没有华丽的界面和炫酷的动效，但我认为简洁也是一种美~ 我相信它会变得越来越好！✨</p>
          <p>💌如果你有任何建议或者想法，欢迎<a href="mailto:fengling27@foxmail.com" class="blink-link">
              <span class="gradient-text">发邮件</span></a>告诉我～🎉
          </p>
          <el-divider></el-divider>
          <p>🚀网站采用前后端分离架构，前端通过动态 meta 标签注入，支持 SSR（服务端渲染）与 CSR（客户端渲染）双模式，提升 SEO 友好性。</p>
          <p>
            <el-tag style="margin-right: 10px;">前端</el-tag>
            <b>Vue + Vuex + VueRouter + VueMeta + ElementUI + Axios + mavonEditor + Less</b>
          </p>
          <p>
            <el-tag style="margin-right: 10px;">渲染层</el-tag>
            <b>Node.js + Express + Vue Server Renderer</b>
          </p>
          <p>
            <el-tag style="margin-right: 10px;">后端服务</el-tag>
            <b>SpringBoot + SpringSecurity + Mybatis + MySQL + Redis</b>
          </p>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: 'About',
  data() {
    return {
      imgUrl: null
    };
  },
  created() {
  },
  metaInfo() {
    return {
      title: '关于 | 风铃笔记',
      meta: [
        { name: 'keywords', content: '风铃笔记, 欢迎来到风铃笔记, 个人博客, 技术分享, Web开发, 前端开发, 后端开发' },
        { name: 'description', content: '关于风铃笔记：这里是「风铃笔记」，一个专注于记录与分享学习点滴的小角落。' }
      ]
    };
  },
  computed: {

  },
  methods: {
  }
}

</script>

<style lang="less" scoped>
.blink-link {
  color: inherit;
  text-decoration: none;
}

.gradient-text {
  // background: linear-gradient(90deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4, #ffeaa7, #dda0dd);
  background: linear-gradient(90deg, #1a73e8, #34a853, #f9ab00, #ea4335, #1a73e8);
  background-size: 300% 300%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: gradient 4s ease infinite;
  display: inline-block;
  font-weight: bold;
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
</style>
